import { VNode, h } from "preact";
import { UIFormProps } from "../FormProvider.js";
import { InputLine } from "./InputLine.js";

export function InputTextArea(props: UIFormProps<string>): VNode {
  return <InputLine type="text-area" {...props} />;
}
